import { render, staticRenderFns } from "./NotenuebersichtModulModal.vue?vue&type=template&id=08467681"
import script from "./NotenuebersichtModulModal.vue?vue&type=script&lang=js"
export * from "./NotenuebersichtModulModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports